import React from "react";
import Gsoc from '../../Assets/gsoc.png';
import RocketChat from '../../Assets/rocket.png'
function ResumeContent(props) {
  return (
    <div className="resume-item">
      {
        props.img ? (
          <div class="resume_image_section">
         
            <img class="gsoc" src={Gsoc} alt="" srcset="" />
            <img class="rocket_chat" src={RocketChat} alt="" srcset="" />
            
          
          </div>
      
        ) : null
      }
      <h5 className={props.title ? "resume-title" : "resume-no-title"}>
        {props.title}
      </h5>
      <p>
        <em>{props.date}</em>
      </p>
      <ul>
        {props.content.map((value, index) => (
          <li key={index}> ‣ {value}</li>
        ))}
      </ul>
    <br/>
    </div>
  );
}

export default ResumeContent;
